import { Container, FeedbackCard } from "@/components"

export const FeedbackResults = () => {
  return(
    <section className="bg-white py-16">
      <Container>
        <div className="flex flex-col lg:flex-row gap-4">
          <div className="w-full lg:w-1/2">
            <img className="w-16 mb-4" src="/images/exclamation-icon.svg" alt="Feedback" />

            <span className="block text-xl weight-800 color-green-500 text-uppercase">Feedback</span>
            <h2 className="text-4xl weight-800 color-black text-uppercase mb-2">Your latest results</h2>
            <p>Review your results</p>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col gap-4">
            <FeedbackCard 
              completedDate={new Date()}
              href="/feedback"
              percentageComplete={100}
              title='Where you started'
            />
            <FeedbackCard 
              href="/feedback"
              percentageComplete={100}
              title='After Health4Life'
            />
            <FeedbackCard 
              href="/feedback"
              percentageComplete={20}
              title='1 year after Health4Life'
            />
            <FeedbackCard 
              href="/feedback"
              percentageComplete={0}
              title='2 years after Health4Life'
              isLocked
            />
          </div>
        </div>
      </Container>
    </section>
  )
}